const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalogarius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dec4b8",
    d: "M 544.5,137.5 C 551.508,137.334 558.508,137.5 565.5,138C 567.058,138.21 568.391,138.71 569.5,139.5C 560.988,139.2 552.655,138.533 544.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#742308",
    d: "M 544.5,137.5 C 552.655,138.533 560.988,139.2 569.5,139.5C 605.77,144.734 640.437,155.234 673.5,171C 682.033,174.508 690.866,176.675 700,177.5C 705.923,177.316 711.756,176.482 717.5,175C 727.177,170.831 730.01,163.998 726,154.5C 721.85,151.502 717.35,150.835 712.5,152.5C 711.686,150.048 712.186,147.715 714,145.5C 715.973,143.772 717.806,141.939 719.5,140C 736.608,137.553 748.941,144.053 756.5,159.5C 759.774,177.923 756.94,195.256 748,211.5C 744.644,217.004 741.144,222.337 737.5,227.5C 736.522,227.811 735.855,228.478 735.5,229.5C 737.396,230.466 739.396,230.799 741.5,230.5C 741.842,231.338 742.508,231.672 743.5,231.5C 744.833,233.5 746.5,235.167 748.5,236.5C 755.04,244.518 753.373,247.685 743.5,246C 737.865,247.647 733.365,250.814 730,255.5C 724.407,268.801 722.907,282.467 725.5,296.5C 726.934,298.22 727.767,300.22 728,302.5C 728.671,303.252 729.504,303.586 730.5,303.5C 737.03,308.022 742.697,307.022 747.5,300.5C 747.5,300.167 747.5,299.833 747.5,299.5C 748.932,296.733 748.599,294.066 746.5,291.5C 748.045,290.548 749.712,290.215 751.5,290.5C 754.426,292.084 757.092,294.084 759.5,296.5C 762.289,303.645 761.956,310.645 758.5,317.5C 755.833,319.5 753.5,321.833 751.5,324.5C 734.823,331.108 721.656,326.775 712,311.5C 702.817,285.998 689.817,262.665 673,241.5C 669.905,238.233 666.738,235.233 663.5,232.5C 660.167,227.167 655.833,222.833 650.5,219.5C 625.985,196.664 597.319,181.164 564.5,173C 547.321,169.179 529.988,168.013 512.5,169.5C 506.916,169.255 501.583,169.922 496.5,171.5C 453.879,180.306 417.546,200.306 387.5,231.5C 385.167,233.167 383.167,235.167 381.5,237.5C 380.197,239.142 378.864,240.809 377.5,242.5C 374.355,245.46 371.688,248.793 369.5,252.5C 359.181,263.788 350.848,276.455 344.5,290.5C 342.412,292.336 341.079,294.669 340.5,297.5C 330.792,316.109 323.126,335.609 317.5,356C 305.526,355.253 293.526,355.419 281.5,356.5C 278.132,357.702 275.966,360.035 275,363.5C 274.803,368.086 274.303,372.586 273.5,377C 265.685,378.114 258.018,379.781 250.5,382C 248.19,383.637 246.69,385.804 246,388.5C 245.5,486.499 245.333,584.499 245.5,682.5C 244.041,682.567 242.708,682.234 241.5,681.5C 239.554,677.561 237.221,673.894 234.5,670.5C 230.9,664.962 227.566,659.296 224.5,653.5C 223.921,650.669 222.588,648.336 220.5,646.5C 196.579,595.399 185.246,541.565 186.5,485C 186.535,470.816 187.035,456.649 188,442.5C 191.463,401.647 201.296,362.647 217.5,325.5C 219.293,323.574 220.293,321.241 220.5,318.5C 233.931,291.979 250.597,267.646 270.5,245.5C 275.167,241.5 279.5,237.167 283.5,232.5C 285.833,230.833 287.833,228.833 289.5,226.5C 299.494,218.174 309.494,209.841 319.5,201.5C 321.853,200.66 323.853,199.326 325.5,197.5C 372.777,165.393 425.11,145.893 482.5,139C 503.15,137.818 523.817,137.318 544.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbbfb3",
    d: "M 512.5,169.5 C 507.432,171.178 502.098,171.844 496.5,171.5C 501.583,169.922 506.916,169.255 512.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b89183",
    d: "M 325.5,197.5 C 323.853,199.326 321.853,200.66 319.5,201.5C 320.802,199.178 322.802,197.845 325.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#975e46",
    d: "M 571.5,212.5 C 572.097,217.294 571.43,221.627 569.5,225.5C 569.438,220.924 570.105,216.591 571.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7a69a",
    d: "M 650.5,219.5 C 655.833,222.833 660.167,227.167 663.5,232.5C 658.745,228.412 654.412,224.078 650.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be9683",
    d: "M 737.5,227.5 C 738.448,228.978 739.781,229.978 741.5,230.5C 739.396,230.799 737.396,230.466 735.5,229.5C 735.855,228.478 736.522,227.811 737.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be9387",
    d: "M 289.5,226.5 C 287.833,228.833 285.833,230.833 283.5,232.5C 284.5,229.5 286.5,227.5 289.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb9086",
    d: "M 743.5,231.5 C 746.167,232.167 747.833,233.833 748.5,236.5C 746.5,235.167 744.833,233.5 743.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29e91",
    d: "M 387.5,231.5 C 386.5,234.5 384.5,236.5 381.5,237.5C 383.167,235.167 385.167,233.167 387.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cba599",
    d: "M 283.5,232.5 C 279.5,237.167 275.167,241.5 270.5,245.5C 271.713,242.775 273.546,240.441 276,238.5C 276.483,237.552 276.649,236.552 276.5,235.5C 279.038,234.957 281.372,233.957 283.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7bcb2",
    d: "M 377.5,242.5 C 376.262,246.976 373.595,250.31 369.5,252.5C 371.688,248.793 374.355,245.46 377.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#772910",
    d: "M 522.5,202.5 C 524.017,202.511 525.184,203.177 526,204.5C 526.167,208.333 526.333,212.167 526.5,216C 526.823,259.325 526.49,302.658 525.5,346C 525.167,356.833 524.833,367.667 524.5,378.5C 523.28,379.711 522.113,379.711 521,378.5C 519.999,319.753 520.499,261.087 522.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6a494",
    d: "M 661.5,283.5 C 663.288,277.616 661.621,276.282 656.5,279.5C 656.414,278.504 656.748,277.671 657.5,277C 660.862,275.707 662.862,276.707 663.5,280C 663.613,281.699 662.947,282.866 661.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9282",
    d: "M 751.5,290.5 C 755.627,290.635 758.294,292.635 759.5,296.5C 757.092,294.084 754.426,292.084 751.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc0b4",
    d: "M 566.5,285.5 C 566.665,288.85 566.498,292.183 566,295.5C 565.768,296.737 565.268,297.737 564.5,298.5C 564.438,293.924 565.105,289.591 566.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9a294",
    d: "M 649.5,291.5 C 648.921,294.331 647.588,296.664 645.5,298.5C 646.079,295.669 647.412,293.336 649.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd9585",
    d: "M 344.5,290.5 C 343.921,293.331 342.588,295.664 340.5,297.5C 341.079,294.669 342.412,292.336 344.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73250c",
    d: "M 467.5,209.5 C 470.649,210.16 472.149,212.16 472,215.5C 482.331,269.823 491.664,324.156 500,378.5C 498.667,379.833 497.333,379.833 496,378.5C 486.121,323.513 476.287,268.513 466.5,213.5C 466.623,212.075 466.957,210.742 467.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ceab9d",
    d: "M 751.5,290.5 C 749.712,290.215 748.045,290.548 746.5,291.5C 748.599,294.066 748.932,296.733 747.5,299.5C 746.263,296.806 745.596,293.473 745.5,289.5C 747.735,289.205 749.735,289.539 751.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#74250d",
    d: "M 566.5,285.5 C 565.105,289.591 564.438,293.924 564.5,298.5C 564.5,298.833 564.5,299.167 564.5,299.5C 562.192,309.934 560.525,320.601 559.5,331.5C 556.427,346.007 554.094,360.674 552.5,375.5C 549.739,376.085 548.073,375.085 547.5,372.5C 555.156,323.564 562.489,274.564 569.5,225.5C 571.43,221.627 572.097,217.294 571.5,212.5C 572.3,210.259 573.966,209.259 576.5,209.5C 576.452,216.197 575.952,222.864 575,229.5C 571.623,248.094 568.79,266.76 566.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73270f",
    d: "M 621.5,238.5 C 625.071,238.408 626.238,240.074 625,243.5C 612.78,275.496 601.78,307.829 592,340.5C 587.951,349.307 584.284,358.307 581,367.5C 579.644,368.38 578.144,368.714 576.5,368.5C 576.896,364.625 577.562,360.792 578.5,357C 593.055,317.633 607.389,278.133 621.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd9584",
    d: "M 437.5,293.5 C 439.267,295.792 440.267,298.458 440.5,301.5C 438.733,299.208 437.733,296.542 437.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5d0c7",
    d: "M 645.5,298.5 C 643.336,303.5 640.669,308.167 637.5,312.5C 638.005,309.657 639.005,306.99 640.5,304.5C 640.392,303.558 640.059,302.725 639.5,302C 641.578,300.923 643.578,299.757 645.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbbcb2",
    d: "M 747.5,300.5 C 742.697,307.022 737.03,308.022 730.5,303.5C 734.446,304.527 738.446,304.694 742.5,304C 743.789,302.198 745.456,301.031 747.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73250c",
    d: "M 449.5,326.5 C 448.354,321.562 446.687,316.895 444.5,312.5C 443.541,308.617 442.208,304.95 440.5,301.5C 440.267,298.458 439.267,295.792 437.5,293.5C 432.175,276.359 426.342,259.359 420,242.5C 419.506,240.866 419.34,239.199 419.5,237.5C 420.978,237.238 422.311,237.571 423.5,238.5C 440.944,284.493 457.61,330.826 473.5,377.5C 472.127,377.657 470.793,377.49 469.5,377C 468.206,374.913 467.039,372.746 466,370.5C 461.165,355.485 455.665,340.819 449.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf9686",
    d: "M 356.5,315.5 C 359.978,313.67 362.311,314.67 363.5,318.5C 361.787,316.15 359.453,315.15 356.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6baad",
    d: "M 444.5,312.5 C 446.687,316.895 448.354,321.562 449.5,326.5C 446.424,322.393 444.758,317.727 444.5,312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebddd4",
    d: "M 564.5,299.5 C 564.19,307.841 563.69,316.174 563,324.5C 561.982,323.294 561.482,323.627 561.5,325.5C 563.077,328.331 562.41,330.331 559.5,331.5C 560.525,320.601 562.192,309.934 564.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6a091",
    d: "M 220.5,318.5 C 220.293,321.241 219.293,323.574 217.5,325.5C 217.707,322.759 218.707,320.426 220.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5a194",
    d: "M 758.5,317.5 C 757.167,320.833 754.833,323.167 751.5,324.5C 753.5,321.833 755.833,319.5 758.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75260e",
    d: "M 356.5,315.5 C 359.453,315.15 361.787,316.15 363.5,318.5C 368.044,324.949 373.044,330.949 378.5,336.5C 379.419,339.089 381.086,341.089 383.5,342.5C 387.181,346.023 390.347,350.023 393,354.5C 394.128,356.345 394.628,358.345 394.5,360.5C 393.127,360.657 391.793,360.49 390.5,360C 388.333,356.667 385.666,353.834 382.5,351.5C 381.92,349.251 380.587,347.585 378.5,346.5C 377.92,344.251 376.587,342.585 374.5,341.5C 373.581,338.911 371.914,336.911 369.5,335.5C 365.592,330.046 361.425,324.713 357,319.5C 356.51,318.207 356.343,316.873 356.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73250d",
    d: "M 661.5,283.5 C 645.526,310.103 629.526,336.77 613.5,363.5C 612.41,365.003 611.243,365.336 610,364.5C 609.333,362.833 609.333,361.167 610,359.5C 619.694,344.107 628.861,328.44 637.5,312.5C 640.669,308.167 643.336,303.5 645.5,298.5C 647.588,296.664 648.921,294.331 649.5,291.5C 652.623,288.024 654.957,284.024 656.5,279.5C 661.621,276.282 663.288,277.616 661.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0b5a7",
    d: "M 688.5,320.5 C 686.976,325.359 683.976,329.025 679.5,331.5C 682.129,327.537 685.129,323.871 688.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72260d",
    d: "M 688.5,320.5 C 685.129,323.871 682.129,327.537 679.5,331.5C 677.413,332.585 676.08,334.251 675.5,336.5C 671.043,339.619 667.709,343.619 665.5,348.5C 662.001,351.166 659.001,354.333 656.5,358C 655.207,358.49 653.873,358.657 652.5,358.5C 652.343,357.127 652.51,355.793 653,354.5C 660.43,345.314 668.096,336.314 676,327.5C 677.439,325.725 678.439,323.725 679,321.5C 682.36,319.134 685.36,316.467 688,313.5C 691.12,315.467 691.287,317.801 688.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf9b8f",
    d: "M 679.5,331.5 C 678.92,333.749 677.587,335.415 675.5,336.5C 676.08,334.251 677.413,332.585 679.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c09789",
    d: "M 369.5,335.5 C 371.914,336.911 373.581,338.911 374.5,341.5C 372.086,340.089 370.419,338.089 369.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73250d",
    d: "M 382.5,279.5 C 384.722,279.178 386.556,279.845 388,281.5C 405.684,310.203 422.851,339.203 439.5,368.5C 437.125,371.123 434.959,370.789 433,367.5C 417.183,339.868 400.85,312.535 384,285.5C 382.872,283.655 382.372,281.655 382.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb8f81",
    d: "M 378.5,336.5 C 380.914,337.911 382.581,339.911 383.5,342.5C 381.086,341.089 379.419,339.089 378.5,336.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc978c",
    d: "M 374.5,341.5 C 376.587,342.585 377.92,344.251 378.5,346.5C 376.413,345.415 375.08,343.749 374.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1afa3",
    d: "M 675.5,336.5 C 672.537,340.798 669.203,344.798 665.5,348.5C 667.709,343.619 671.043,339.619 675.5,336.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8a598",
    d: "M 378.5,346.5 C 380.587,347.585 381.92,349.251 382.5,351.5C 380.413,350.415 379.08,348.749 378.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1c7ba",
    d: "M 345.5,367.5 C 352.852,367.668 360.185,368.168 367.5,369C 368.056,369.383 368.389,369.883 368.5,370.5C 360.62,370.083 352.953,369.083 345.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c250e",
    d: "M 788.5,336.5 C 792.652,336.631 793.318,338.131 790.5,341C 768.894,354.942 747.561,369.275 726.5,384C 724.866,384.494 723.199,384.66 721.5,384.5C 721.393,382.097 722.393,380.264 724.5,379C 746.414,365.555 767.747,351.388 788.5,336.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#74260e",
    d: "M 822.5,377.5 C 826.652,377.631 827.318,379.131 824.5,382C 791.957,397.73 759.291,413.063 726.5,428C 724.866,428.494 723.199,428.66 721.5,428.5C 721.286,426.856 721.62,425.356 722.5,424C 739.345,416.743 755.678,408.743 771.5,400C 789.035,393.562 806.035,386.062 822.5,377.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a26e5d",
    d: "M 685.5,378.5 C 686.483,382.298 686.817,386.298 686.5,390.5C 693.841,390.334 701.174,390.5 708.5,391C 709.252,391.671 709.586,392.504 709.5,393.5C 708.711,393.217 708.044,392.717 707.5,392C 700.174,391.5 692.841,391.334 685.5,391.5C 685.5,387.167 685.5,382.833 685.5,378.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72250d",
    d: "M 836.5,435.5 C 838.635,435.147 839.968,435.98 840.5,438C 840.18,439.653 839.18,440.653 837.5,441C 799.573,449.251 761.74,457.751 724,466.5C 720.808,462.604 721.975,460.437 727.5,460C 764.029,452.031 800.362,443.865 836.5,435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c3017",
    d: "M 842.5,494.5 C 842.714,496.144 842.38,497.644 841.5,499C 819.169,499.5 796.836,499.667 774.5,499.5C 772.5,499.5 770.5,499.5 768.5,499.5C 753.496,499.667 738.496,499.5 723.5,499C 722.62,497.644 722.286,496.144 722.5,494.5C 762.5,493.167 802.5,493.167 842.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8a399",
    d: "M 722.5,494.5 C 722.286,496.144 722.62,497.644 723.5,499C 738.496,499.5 753.496,499.667 768.5,499.5C 753.339,500.661 738.006,500.828 722.5,500C 721.193,498.057 721.193,496.223 722.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6a097",
    d: "M 842.5,494.5 C 843.807,496.223 843.807,498.057 842.5,500C 819.663,500.83 796.996,500.663 774.5,499.5C 796.836,499.667 819.169,499.5 841.5,499C 842.38,497.644 842.714,496.144 842.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73250c",
    d: "M 721.5,525.5 C 759.252,531.75 796.919,538.583 834.5,546C 836.107,547.049 836.773,548.549 836.5,550.5C 798.343,544.628 760.343,537.795 722.5,530C 721.62,528.644 721.286,527.144 721.5,525.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#702411",
    d: "M 325.5,366.5 C 313.505,365.758 301.505,365.591 289.5,366C 287.77,367.852 286.604,367.686 286,365.5C 285.667,366.167 285.333,366.833 285,367.5C 284.5,460.499 284.333,553.499 284.5,646.5C 283.334,553.334 283.168,460.001 284,366.5C 285.028,364.484 286.695,363.484 289,363.5C 301.343,364.124 313.51,365.124 325.5,366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ba9182",
    d: "M 220.5,646.5 C 222.588,648.336 223.921,650.669 224.5,653.5C 222.412,651.664 221.079,649.331 220.5,646.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c49f91",
    d: "M 234.5,670.5 C 237.221,673.894 239.554,677.561 241.5,681.5C 237.99,678.642 235.657,674.976 234.5,670.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#742309",
    d: "M 325.5,366.5 C 332.167,366.833 338.833,367.167 345.5,367.5C 352.953,369.083 360.62,370.083 368.5,370.5C 410.275,376.314 449.608,389.314 486.5,409.5C 487.145,410.812 488.145,411.812 489.5,412.5C 493.389,410.726 497.055,408.726 500.5,406.5C 527.46,395.091 555.46,387.091 584.5,382.5C 587.85,382.665 591.183,382.498 594.5,382C 595.737,381.768 596.737,381.268 597.5,380.5C 626.382,376.676 655.382,375.176 684.5,376C 685.252,376.671 685.586,377.504 685.5,378.5C 685.5,382.833 685.5,387.167 685.5,391.5C 692.841,391.334 700.174,391.5 707.5,392C 708.044,392.717 708.711,393.217 709.5,393.5C 709.333,442.834 709.5,492.168 710,541.5C 739.227,561.725 768.727,581.558 798.5,601C 800.657,602.912 802.991,604.579 805.5,606C 806.894,606.956 807.561,608.289 807.5,610C 807.007,612.819 805.84,615.319 804,617.5C 789.614,636.219 775.614,655.219 762,674.5C 758.777,687.005 754.277,699.005 748.5,710.5C 746.674,712.147 745.34,714.147 744.5,716.5C 741.117,720.553 738.117,724.886 735.5,729.5C 733.413,730.585 732.08,732.251 731.5,734.5C 729.413,735.585 728.08,737.251 727.5,739.5C 722.414,744.978 717.414,750.478 712.5,756C 725.842,754.983 734.175,760.816 737.5,773.5C 737.324,779.834 734.324,783.834 728.5,785.5C 728.802,782.941 728.468,780.607 727.5,778.5C 727.033,775.703 725.367,774.369 722.5,774.5C 716.933,773.196 711.266,773.196 705.5,774.5C 702.505,774.294 699.838,774.96 697.5,776.5C 684.51,780.83 672.177,786.496 660.5,793.5C 657.759,793.707 655.426,794.707 653.5,796.5C 626.219,808.573 597.886,817.406 568.5,823C 536.176,826.662 503.843,827.162 471.5,824.5C 466.384,823.194 461.051,822.527 455.5,822.5C 443.637,820.186 431.637,817.852 419.5,815.5C 408.159,812.165 396.825,808.832 385.5,805.5C 379.789,802.653 373.789,800.32 367.5,798.5C 339.172,786.678 313.839,770.345 291.5,749.5C 290.415,747.413 288.749,746.08 286.5,745.5C 283.551,740.365 279.218,737.865 273.5,738C 272.28,739.525 271.613,741.359 271.5,743.5C 271.316,746.205 271.983,748.538 273.5,750.5C 274.167,753.167 275.833,754.833 278.5,755.5C 283.137,758.824 287.804,762.157 292.5,765.5C 281.376,769.507 271.376,767.507 262.5,759.5C 259.388,756.263 257.054,752.596 255.5,748.5C 254.042,741.403 252.709,734.403 251.5,727.5C 251.269,718.202 247.269,711.035 239.5,706C 241.026,704.113 243.026,703.113 245.5,703C 284.497,702.178 323.497,701.678 362.5,701.5C 367.683,700.535 372.016,701.868 375.5,705.5C 378.015,711.348 381.682,716.348 386.5,720.5C 387.419,723.089 389.086,725.089 391.5,726.5C 391.5,727.167 391.833,727.5 392.5,727.5C 395.5,732.5 399.5,736.5 404.5,739.5C 405.833,741.5 407.5,743.167 409.5,744.5C 411.8,746.984 414.467,748.984 417.5,750.5C 427.352,759.262 438.352,766.262 450.5,771.5C 452.579,773.873 455.246,775.206 458.5,775.5C 464.349,778.108 470.349,780.608 476.5,783C 480.112,784.15 483.778,784.983 487.5,785.5C 489.838,787.04 492.505,787.706 495.5,787.5C 535.79,795.782 575.123,792.282 613.5,777C 619.506,774.663 625.173,771.83 630.5,768.5C 632.366,767.986 634.2,767.32 636,766.5C 638.724,767.838 639.891,766.838 639.5,763.5C 642.344,763.657 644.011,762.324 644.5,759.5C 648.688,755.914 653.022,752.581 657.5,749.5C 659.749,748.92 661.415,747.587 662.5,745.5C 663.167,744.833 663.833,744.167 664.5,743.5C 667.089,742.581 669.089,740.914 670.5,738.5C 671.167,738.5 671.5,738.167 671.5,737.5C 674.764,735.906 677.431,733.573 679.5,730.5C 682.466,728.201 685.132,725.534 687.5,722.5C 689.833,720.833 691.833,718.833 693.5,716.5C 690.069,713.573 686.736,710.406 683.5,707C 675.95,703.078 668.95,698.411 662.5,693C 617.5,692.333 572.5,692.333 527.5,693C 519.064,696.05 510.731,699.384 502.5,703C 490.024,706.656 477.691,706.323 465.5,702C 460.454,698.811 455.121,696.144 449.5,694C 385.506,692.842 321.506,692.175 257.5,692C 256.299,691.097 255.465,689.931 255,688.5C 254.333,589.5 254.333,490.5 255,391.5C 255.903,390.299 257.069,389.465 258.5,389C 263.839,388.118 269.173,387.285 274.5,386.5C 273.4,481.497 273.4,576.497 274.5,671.5C 313.12,668.43 351.787,667.763 390.5,669.5C 407.35,672.065 424.35,674.231 441.5,676C 431.478,671.271 421.145,667.438 410.5,664.5C 408.485,663.076 406.152,662.41 403.5,662.5C 391.878,658.808 379.878,656.308 367.5,655C 340.234,651.885 312.901,649.552 285.5,648C 284.944,647.617 284.611,647.117 284.5,646.5C 284.333,553.499 284.5,460.499 285,367.5C 285.333,366.833 285.667,366.167 286,365.5C 286.604,367.686 287.77,367.852 289.5,366C 301.505,365.591 313.505,365.758 325.5,366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb9685",
    d: "M 659.5,680.5 C 662.37,681.433 664.704,683.1 666.5,685.5C 663.63,684.567 661.296,682.9 659.5,680.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc2b7",
    d: "M 564.5,668.5 C 563.411,670.117 561.744,670.95 559.5,671C 563.152,671.499 566.818,671.665 570.5,671.5C 560.661,673.17 550.661,674.336 540.5,675C 548.382,672.316 556.382,670.149 564.5,668.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a67766",
    d: "M 626.5,668.5 C 628.09,668.628 629.423,669.295 630.5,670.5C 612.512,671.5 594.512,671.833 576.5,671.5C 593.328,670.668 610.328,670.168 627.5,670C 626.944,669.617 626.611,669.117 626.5,668.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5d3cc",
    d: "M 410.5,664.5 C 421.145,667.438 431.478,671.271 441.5,676C 424.35,674.231 407.35,672.065 390.5,669.5C 396.713,669.963 402.88,669.963 409,669.5C 409.833,669.167 410.667,668.833 411.5,668.5C 410.754,667.264 410.421,665.93 410.5,664.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c49e92",
    d: "M 491.5,651.5 C 491.841,663.037 492.841,674.37 494.5,685.5C 493.828,686.267 492.995,686.934 492,687.5C 491.5,675.505 491.333,663.505 491.5,651.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b69589",
    d: "M 403.5,662.5 C 406.152,662.41 408.485,663.076 410.5,664.5C 407.848,664.59 405.515,663.924 403.5,662.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f2ee",
    d: "M 608.5,660.5 C 611.237,660.401 613.904,660.735 616.5,661.5C 620.221,663.354 623.554,665.687 626.5,668.5C 626.611,669.117 626.944,669.617 627.5,670C 610.328,670.168 593.328,670.668 576.5,671.5C 574.5,671.5 572.5,671.5 570.5,671.5C 566.818,671.665 563.152,671.499 559.5,671C 561.744,670.95 563.411,670.117 564.5,668.5C 578.814,664.557 593.48,661.89 608.5,660.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8897d",
    d: "M 608.5,660.5 C 609.449,659.848 610.615,659.514 612,659.5C 614.008,659.307 615.508,659.974 616.5,661.5C 613.904,660.735 611.237,660.401 608.5,660.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8d5ce",
    d: "M 585.5,640.5 C 592.119,644.149 598.452,648.315 604.5,653C 597.89,654.326 591.224,655.16 584.5,655.5C 585.871,653.859 587.704,652.859 590,652.5C 593.154,654.345 595.321,653.678 596.5,650.5C 596.292,647.815 595.125,647.149 593,648.5C 590.931,647.736 588.764,647.236 586.5,647C 587.022,646.439 587.355,645.772 587.5,645C 586.293,643.7 585.626,642.2 585.5,640.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2c6bc",
    d: "M 558.5,621.5 C 563.527,624.345 568.194,627.679 572.5,631.5C 566.439,630.103 561.772,626.77 558.5,621.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9384",
    d: "M 794.5,609.5 C 796.252,609.418 797.252,610.251 797.5,612C 796.749,614.912 795.082,617.079 792.5,618.5C 793.581,616.236 794.915,614.069 796.5,612C 795.619,611.292 794.953,610.458 794.5,609.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#985c49",
    d: "M 518.5,575.5 C 517.831,579.856 515.498,582.856 511.5,584.5C 513.809,581.519 516.143,578.519 518.5,575.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#985d49",
    d: "M 531.5,558.5 C 531.657,559.873 531.49,561.207 531,562.5C 529.008,563.665 527.175,564.998 525.5,566.5C 527.016,563.467 529.016,560.8 531.5,558.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c09687",
    d: "M 548.5,551.5 C 547.92,553.749 546.587,555.415 544.5,556.5C 545.08,554.251 546.413,552.585 548.5,551.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c49f94",
    d: "M 557.5,539.5 C 556.753,542.362 555.086,544.362 552.5,545.5C 553.701,543.091 555.367,541.091 557.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be9788",
    d: "M 561.5,534.5 C 560.92,536.749 559.587,538.415 557.5,539.5C 558.08,537.251 559.413,535.585 561.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a624c",
    d: "M 555.5,527.5 C 555.657,528.873 555.49,530.207 555,531.5C 552.672,532.999 550.505,534.666 548.5,536.5C 550.458,533.208 552.791,530.208 555.5,527.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfaf7",
    d: "M 794.5,609.5 C 794.953,610.458 795.619,611.292 796.5,612C 794.915,614.069 793.581,616.236 792.5,618.5C 776.644,640.89 760.311,662.89 743.5,684.5C 741.086,685.911 739.419,687.911 738.5,690.5C 731.885,700.208 724.885,709.708 717.5,719C 716.167,719.667 714.833,719.667 713.5,719C 708.315,715.303 703.315,711.47 698.5,707.5C 697.198,705.178 695.198,703.845 692.5,703.5C 683.553,697.883 674.886,691.883 666.5,685.5C 664.704,683.1 662.37,681.433 659.5,680.5C 613.21,649.347 567.21,617.68 521.5,585.5C 528.84,575.502 536.507,565.836 544.5,556.5C 546.587,555.415 547.92,553.749 548.5,551.5C 549.449,549.223 550.782,547.223 552.5,545.5C 555.086,544.362 556.753,542.362 557.5,539.5C 559.587,538.415 560.92,536.749 561.5,534.5C 573.982,517.559 586.482,500.559 599,483.5C 600.351,481.981 601.851,480.648 603.5,479.5C 654.616,514.232 705.949,548.732 757.5,583C 770.263,591.368 782.596,600.201 794.5,609.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c19b8d",
    d: "M 704.5,638.5 C 707.167,640.5 709.5,642.833 711.5,645.5C 708.167,644.167 705.833,641.833 704.5,638.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75250c",
    d: "M 711.5,645.5 C 709.5,642.833 707.167,640.5 704.5,638.5C 703.617,635.296 701.95,632.629 699.5,630.5C 698.92,628.251 697.587,626.585 695.5,625.5C 691.944,621.055 687.277,618.722 681.5,618.5C 680.081,617.549 678.415,617.216 676.5,617.5C 676.5,615.833 676.5,614.167 676.5,612.5C 678.865,611.992 681.199,611.325 683.5,610.5C 688.608,612.22 693.608,614.22 698.5,616.5C 704.864,624.063 710.864,631.897 716.5,640C 721.415,643.124 726.748,645.124 732.5,646C 733.664,650.016 731.997,651.85 727.5,651.5C 722.669,650.959 718.002,649.792 713.5,648C 712.619,647.292 711.953,646.458 711.5,645.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3a091",
    d: "M 695.5,625.5 C 697.587,626.585 698.92,628.251 699.5,630.5C 697.413,629.415 696.08,627.749 695.5,625.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf9b91",
    d: "M 723.5,615.5 C 725.833,617.167 727.833,619.167 729.5,621.5C 726.5,620.5 724.5,618.5 723.5,615.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a88071",
    d: "M 676.5,612.5 C 676.5,614.167 676.5,615.833 676.5,617.5C 678.415,617.216 680.081,617.549 681.5,618.5C 679.5,618.5 677.5,618.5 675.5,618.5C 675.205,616.265 675.539,614.265 676.5,612.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf998e",
    d: "M 708.5,598.5 C 711.674,599.01 714.008,600.677 715.5,603.5C 712.883,602.214 710.55,600.547 708.5,598.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be998e",
    d: "M 715.5,592.5 C 718.833,593.833 721.167,596.167 722.5,599.5C 719.833,597.5 717.5,595.167 715.5,592.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#74240b",
    d: "M 715.5,592.5 C 717.5,595.167 719.833,597.5 722.5,599.5C 728.999,612.828 739.499,621.161 754,624.5C 754.76,629.074 752.76,631.074 748,630.5C 741.22,628.693 735.053,625.693 729.5,621.5C 727.833,619.167 725.833,617.167 723.5,615.5C 721.327,611.148 718.66,607.148 715.5,603.5C 714.008,600.677 711.674,599.01 708.5,598.5C 704.645,595.965 700.312,594.965 695.5,595.5C 695.104,592.956 695.771,590.789 697.5,589C 703.876,588.261 709.876,589.428 715.5,592.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#732309",
    d: "M 605.5,501.5 C 626.068,513.459 646.401,525.959 666.5,539C 667.022,539.561 667.355,540.228 667.5,541C 650.058,564.94 632.058,588.44 613.5,611.5C 593.119,598.65 573.119,585.316 553.5,571.5C 570.472,547.866 587.806,524.533 605.5,501.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf9f6",
    d: "M 615.5,528.5 C 630.263,528.755 637.096,536.088 636,550.5C 633.449,554.293 630.449,557.626 627,560.5C 625.748,563.014 625.248,565.68 625.5,568.5C 620.126,567.937 615.959,569.937 613,574.5C 612.667,578.833 612.333,583.167 612,587.5C 600.661,587.576 590.327,584.243 581,577.5C 580.175,575.299 580.675,573.466 582.5,572C 587.439,570.392 592.273,568.559 597,566.5C 599.518,562.298 598.518,559.298 594,557.5C 593.333,555.833 593.333,554.167 594,552.5C 598,546.5 602,540.5 606,534.5C 608.551,531.319 611.718,529.319 615.5,528.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#854534",
    d: "M 677.5,460.5 C 678.828,480.004 678.828,499.671 677.5,519.5C 676.893,519.376 676.56,519.043 676.5,518.5C 677.497,499.341 677.83,480.007 677.5,460.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c59e93",
    d: "M 479.5,418.5 C 481.017,418.511 482.184,419.177 483,420.5C 483.5,452.165 483.667,483.832 483.5,515.5C 482.668,484.336 482.168,453.003 482,421.5C 480.955,420.627 480.122,419.627 479.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a47162",
    d: "M 695.5,401.5 C 697.167,401.5 698.833,401.5 700.5,401.5C 700.833,445.838 700.5,490.172 699.5,534.5C 698.145,533.812 697.145,532.812 696.5,531.5C 697.496,531.414 698.329,531.748 699,532.5C 699.5,489.168 699.667,445.835 699.5,402.5C 697.901,402.768 696.568,402.434 695.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cca798",
    d: "M 500.5,406.5 C 497.055,408.726 493.389,410.726 489.5,412.5C 488.145,411.812 487.145,410.812 486.5,409.5C 487.695,409.678 488.862,410.011 490,410.5C 493.25,408.393 496.75,407.06 500.5,406.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf7f4",
    d: "M 695.5,401.5 C 696.568,402.434 697.901,402.768 699.5,402.5C 699.667,445.835 699.5,489.168 699,532.5C 698.329,531.748 697.496,531.414 696.5,531.5C 692.799,529.559 689.299,527.226 686,524.5C 685.5,483.501 685.333,442.501 685.5,401.5C 688.833,401.5 692.167,401.5 695.5,401.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1c4b9",
    d: "M 303.5,372.5 C 300.167,372.5 296.833,372.5 293.5,372.5C 293.5,461.833 293.5,551.167 293.5,640.5C 292.501,551.002 292.167,461.335 292.5,371.5C 296.371,371.185 300.038,371.518 303.5,372.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1cbbf",
    d: "M 623.5,385.5 C 615.193,387.053 606.86,388.719 598.5,390.5C 595.579,389.593 592.579,389.26 589.5,389.5C 600.602,387.323 611.935,385.989 623.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd9586",
    d: "M 410.5,387.5 C 413.152,387.41 415.485,388.076 417.5,389.5C 414.848,389.59 412.515,388.924 410.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcf9",
    d: "M 647.5,384.5 C 657.582,384.193 667.582,384.526 677.5,385.5C 677.5,410.5 677.5,435.5 677.5,460.5C 677.83,480.007 677.497,499.341 676.5,518.5C 652.535,502.524 628.868,486.191 605.5,469.5C 601.067,467.417 598.067,468.751 596.5,473.5C 593.754,475.989 591.754,478.989 590.5,482.5C 588.413,483.585 587.08,485.251 586.5,487.5C 584.984,490.533 582.984,493.2 580.5,495.5C 578.08,498.087 575.246,500.087 572,501.5C 571.667,503.167 571.333,504.833 571,506.5C 568.858,508.432 567.358,510.765 566.5,513.5C 562.352,517.8 558.685,522.467 555.5,527.5C 552.791,530.208 550.458,533.208 548.5,536.5C 543.502,544.48 537.835,551.813 531.5,558.5C 529.016,560.8 527.016,563.467 525.5,566.5C 523.518,569.81 521.185,572.81 518.5,575.5C 516.143,578.519 513.809,581.519 511.5,584.5C 511.247,586.827 511.914,588.827 513.5,590.5C 528.816,600.501 543.816,610.835 558.5,621.5C 561.772,626.77 566.439,630.103 572.5,631.5C 577.365,633.763 581.698,636.763 585.5,640.5C 585.626,642.2 586.293,643.7 587.5,645C 587.355,645.772 587.022,646.439 586.5,647C 588.764,647.236 590.931,647.736 593,648.5C 595.125,647.149 596.292,647.815 596.5,650.5C 595.321,653.678 593.154,654.345 590,652.5C 587.704,652.859 585.871,653.859 584.5,655.5C 569.454,658.677 554.454,662.177 539.5,666C 528.064,671.256 516.398,675.923 504.5,680C 501.513,682.492 498.18,684.325 494.5,685.5C 492.841,674.37 491.841,663.037 491.5,651.5C 491.333,574.499 491.5,497.499 492,420.5C 522.508,404.054 555.008,393.72 589.5,389.5C 592.579,389.26 595.579,389.593 598.5,390.5C 606.86,388.719 615.193,387.053 623.5,385.5C 631.458,384.597 639.458,384.264 647.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9beb4",
    d: "M 580.5,495.5 C 576.314,501.871 571.647,507.871 566.5,513.5C 567.358,510.765 568.858,508.432 571,506.5C 571.333,504.833 571.667,503.167 572,501.5C 575.246,500.087 578.08,498.087 580.5,495.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf9485",
    d: "M 590.5,482.5 C 589.92,484.749 588.587,486.415 586.5,487.5C 587.08,485.251 588.413,483.585 590.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7978b",
    d: "M 605.5,469.5 C 603.801,469.34 602.134,469.506 600.5,470C 599.295,471.376 597.962,472.542 596.5,473.5C 598.067,468.751 601.067,467.417 605.5,469.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73240c",
    d: "M 635.5,426.5 C 639.5,426.5 643.5,426.5 647.5,426.5C 647.5,428.167 647.5,429.833 647.5,431.5C 603.165,431.666 560.165,439.166 518.5,454C 512.313,454.094 511.98,452.427 517.5,449C 555.842,435.63 595.175,428.13 635.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf9f95",
    d: "M 647.5,384.5 C 652.322,383.834 657.322,383.501 662.5,383.5C 667.881,383.506 672.881,384.172 677.5,385.5C 667.582,384.526 657.582,384.193 647.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e6652",
    d: "M 597.5,380.5 C 596.737,381.268 595.737,381.768 594.5,382C 591.183,382.498 587.85,382.665 584.5,382.5C 588.618,381.291 592.951,380.624 597.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcfa",
    d: "M 303.5,372.5 C 331.802,373.885 359.802,377.052 387.5,382C 395.429,383.281 403.095,385.114 410.5,387.5C 412.515,388.924 414.848,389.59 417.5,389.5C 436.601,394.556 454.601,402.056 471.5,412C 474.302,414.136 476.968,416.302 479.5,418.5C 480.122,419.627 480.955,420.627 482,421.5C 482.168,453.003 482.668,484.336 483.5,515.5C 483.5,570.833 483.5,626.167 483.5,681.5C 483.799,683.604 483.466,685.604 482.5,687.5C 481.583,686.873 480.583,686.539 479.5,686.5C 458.447,674.141 436.447,663.641 413.5,655C 373.726,647.131 333.726,642.297 293.5,640.5C 293.5,551.167 293.5,461.833 293.5,372.5C 296.833,372.5 300.167,372.5 303.5,372.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72260d",
    d: "M 365.5,594.5 C 397.639,597.367 428.306,605.534 457.5,619C 460.49,622.379 459.824,624.045 455.5,624C 443.935,618.218 431.935,613.551 419.5,610C 400.532,605.288 381.532,601.455 362.5,598.5C 360.097,597.869 357.764,596.869 355.5,595.5C 358.768,594.513 362.102,594.18 365.5,594.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#682a14",
    d: "M 365.5,594.5 C 362.102,594.18 358.768,594.513 355.5,595.5C 357.764,596.869 360.097,597.869 362.5,598.5C 350.772,597.882 339.105,596.715 327.5,595C 325.937,592.524 326.604,591.024 329.5,590.5C 341.895,591.554 353.895,592.888 365.5,594.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71250d",
    d: "M 326.5,557.5 C 363.715,558.542 400.048,564.708 435.5,576C 442.616,578.725 449.616,581.725 456.5,585C 460.788,588.755 460.121,590.422 454.5,590C 426.846,577.341 397.846,569.341 367.5,566C 354.199,564.335 340.866,563.002 327.5,562C 326.833,561.333 326.167,560.667 325.5,560C 326.252,559.329 326.586,558.496 326.5,557.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccab9d",
    d: "M 459.5,551.5 C 460.807,553.223 460.807,555.057 459.5,557C 456.773,557.818 454.106,557.652 451.5,556.5C 451.137,555.817 450.804,555.15 450.5,554.5C 453.012,555.928 455.678,556.428 458.5,556C 459.38,554.644 459.714,553.144 459.5,551.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3cbc1",
    d: "M 416.5,542.5 C 424.051,543.464 431.051,545.797 437.5,549.5C 431.678,547.636 425.678,546.469 419.5,546C 419.833,545.667 420.167,545.333 420.5,545C 419.142,544.066 417.808,543.232 416.5,542.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72230b",
    d: "M 360.5,525.5 C 365.306,526.593 370.306,527.259 375.5,527.5C 381.291,528.987 387.291,529.987 393.5,530.5C 396.219,531.913 399.219,532.58 402.5,532.5C 422.014,537.005 441.014,543.338 459.5,551.5C 459.714,553.144 459.38,554.644 458.5,556C 455.678,556.428 453.012,555.928 450.5,554.5C 446.556,552.036 442.223,550.37 437.5,549.5C 431.051,545.797 424.051,543.464 416.5,542.5C 404.189,538.703 391.523,536.037 378.5,534.5C 378.389,533.883 378.056,533.383 377.5,533C 373.848,532.501 370.182,532.335 366.5,532.5C 353.67,529.938 340.67,528.438 327.5,528C 324.895,526.069 324.895,524.236 327.5,522.5C 338.457,523.779 349.457,524.779 360.5,525.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#975b47",
    d: "M 366.5,532.5 C 370.182,532.335 373.848,532.501 377.5,533C 378.056,533.383 378.389,533.883 378.5,534.5C 374.267,534.461 370.267,533.795 366.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf9b8a",
    d: "M 393.5,530.5 C 396.781,530.42 399.781,531.087 402.5,532.5C 399.219,532.58 396.219,531.913 393.5,530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcbdb0",
    d: "M 360.5,525.5 C 365.783,525.096 370.783,525.762 375.5,527.5C 370.306,527.259 365.306,526.593 360.5,525.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#562110",
    d: "M 443.5,512.5 C 448.25,514.029 452.916,515.863 457.5,518C 460.118,519.974 459.952,521.807 457,523.5C 450.704,520.579 444.538,517.579 438.5,514.5C 440.514,514.608 442.18,513.942 443.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#74260d",
    d: "M 326.5,489.5 C 357.362,490.409 387.696,494.909 417.5,503C 426.58,505.389 435.247,508.555 443.5,512.5C 442.18,513.942 440.514,514.608 438.5,514.5C 403.378,503.276 367.378,496.943 330.5,495.5C 326.307,495.317 324.973,493.317 326.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd9786",
    d: "M 326.5,489.5 C 324.973,493.317 326.307,495.317 330.5,495.5C 328.533,495.739 326.699,495.406 325,494.5C 324.833,493.667 324.667,492.833 324.5,492C 324.684,490.624 325.351,489.791 326.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc4bb",
    d: "M 412.5,467.5 C 418.303,468.44 423.97,468.94 429.5,469C 425.777,470.039 425.777,471.206 429.5,472.5C 423.616,471.282 417.949,469.616 412.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77280f",
    d: "M 412.5,467.5 C 417.949,469.616 423.616,471.282 429.5,472.5C 438.976,475.898 448.309,479.898 457.5,484.5C 460.111,486.798 459.611,488.465 456,489.5C 427.511,476.585 397.677,468.418 366.5,465C 352.799,463.98 339.132,462.814 325.5,461.5C 325.5,459.5 325.5,457.5 325.5,455.5C 337.712,455.328 349.879,455.994 362,457.5C 378.901,460.38 395.734,463.714 412.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#76270f",
    d: "M 325.5,421.5 C 371.365,421.971 415.032,431.804 456.5,451C 460.203,453.772 460.203,456.272 456.5,458.5C 415.423,439.644 372.089,429.478 326.5,428C 324.316,426.102 323.983,423.936 325.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b98372",
    d: "M 483.5,681.5 C 484.909,684.178 484.743,686.844 483,689.5C 481.482,688.837 480.315,687.837 479.5,686.5C 480.583,686.539 481.583,686.873 482.5,687.5C 483.466,685.604 483.799,683.604 483.5,681.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b48675",
    d: "M 743.5,684.5 C 742.581,687.089 740.914,689.089 738.5,690.5C 739.419,687.911 741.086,685.911 743.5,684.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6b7ab",
    d: "M 362.5,701.5 C 365.64,700.359 368.973,700.192 372.5,701C 374.141,702.129 375.141,703.629 375.5,705.5C 372.016,701.868 367.683,700.535 362.5,701.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b99283",
    d: "M 692.5,703.5 C 695.198,703.845 697.198,705.178 698.5,707.5C 696.147,706.66 694.147,705.326 692.5,703.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0978a",
    d: "M 748.5,710.5 C 748.155,713.198 746.822,715.198 744.5,716.5C 745.34,714.147 746.674,712.147 748.5,710.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#74240a",
    d: "M 409.5,701.5 C 410.117,701.611 410.617,701.944 411,702.5C 408.497,717.498 414.663,723.332 429.5,720C 432.883,718.62 434.716,716.12 435,712.5C 437.966,709.735 440.633,710.068 443,713.5C 444.895,718.083 444.728,722.583 442.5,727C 449.225,725.785 456.058,724.952 463,724.5C 469.449,724.257 475.615,725.423 481.5,728C 482.772,730.044 482.439,731.878 480.5,733.5C 478.146,734.06 475.813,734.727 473.5,735.5C 475.5,737.5 477.5,739.5 479.5,741.5C 491.34,732.081 504.673,725.581 519.5,722C 528.595,721.258 537.595,719.924 546.5,718C 550.745,715.424 553.912,711.924 556,707.5C 559.172,710.846 560.672,714.846 560.5,719.5C 569.888,720.541 579.222,720.041 588.5,718C 589.416,717.626 590.25,717.126 591,716.5C 591.742,713.343 593.242,710.677 595.5,708.5C 599.24,711.633 600.407,715.633 599,720.5C 598.626,721.416 598.126,722.25 597.5,723C 606.189,725.547 615.023,727.381 624,728.5C 628.01,728.497 631.844,727.664 635.5,726C 636.916,722.078 638.25,718.078 639.5,714C 646.842,714.349 650.509,718.349 650.5,726C 649.628,736.144 643.962,741.311 633.5,741.5C 630.51,741.377 627.677,740.71 625,739.5C 622.605,744.617 618.772,746.283 613.5,744.5C 611.385,740.278 608.052,738.445 603.5,739C 607.213,745.078 607.38,751.245 604,757.5C 599.811,762.088 594.645,763.588 588.5,762C 581.448,760.476 578.781,756.309 580.5,749.5C 583.421,750.407 586.421,750.74 589.5,750.5C 589.952,745.773 588.285,741.94 584.5,739C 574.136,733.661 563.136,730.994 551.5,731C 554.99,733.911 558.656,736.578 562.5,739C 568.008,745.234 568.841,752.067 565,759.5C 556.999,765.425 549.666,764.758 543,757.5C 541.655,755.17 541.488,752.837 542.5,750.5C 551.178,754.761 553.678,752.761 550,744.5C 540.442,736.09 529.276,732.923 516.5,735C 513.768,735.413 511.101,736.08 508.5,737C 521.404,740.313 526.57,748.48 524,761.5C 522.878,763.624 521.378,765.457 519.5,767C 514.953,768.545 510.287,768.879 505.5,768C 500.489,765.805 498.156,761.971 498.5,756.5C 500.884,756.443 503.218,756.777 505.5,757.5C 507.663,757.255 509.33,756.255 510.5,754.5C 505.763,747.946 499.429,745.779 491.5,748C 485.333,750.167 481.167,754.333 479,760.5C 478.503,763.146 478.336,765.813 478.5,768.5C 469.5,768.167 464.833,763.5 464.5,754.5C 466.665,754.884 468.332,754.217 469.5,752.5C 468.033,741.854 462.033,737.021 451.5,738C 447.296,739.547 443.629,741.88 440.5,745C 436.428,746.336 433.428,745.169 431.5,741.5C 433.021,739.714 433.354,737.881 432.5,736C 421.538,733.936 412.038,729.103 404,721.5C 399.392,712.906 401.226,706.239 409.5,701.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c09889",
    d: "M 693.5,716.5 C 691.833,718.833 689.833,720.833 687.5,722.5C 688.5,719.5 690.5,717.5 693.5,716.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb9182",
    d: "M 386.5,720.5 C 388.914,721.911 390.581,723.911 391.5,726.5C 389.086,725.089 387.419,723.089 386.5,720.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd9789",
    d: "M 392.5,727.5 C 396.833,731.167 400.833,735.167 404.5,739.5C 399.5,736.5 395.5,732.5 392.5,727.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8a295",
    d: "M 735.5,729.5 C 734.92,731.749 733.587,733.415 731.5,734.5C 732.08,732.251 733.413,730.585 735.5,729.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb8f83",
    d: "M 679.5,730.5 C 677.431,733.573 674.764,735.906 671.5,737.5C 673.569,734.427 676.236,732.094 679.5,730.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ba9185",
    d: "M 731.5,734.5 C 730.92,736.749 729.587,738.415 727.5,739.5C 728.08,737.251 729.413,735.585 731.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9081",
    d: "M 670.5,738.5 C 669.089,740.914 667.089,742.581 664.5,743.5C 665.911,741.086 667.911,739.419 670.5,738.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfcabe",
    d: "M 251.5,727.5 C 252.709,734.403 254.042,741.403 255.5,748.5C 254.127,748.657 252.793,748.49 251.5,748C 252.331,741.238 252.331,734.405 251.5,727.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9181",
    d: "M 286.5,745.5 C 288.749,746.08 290.415,747.413 291.5,749.5C 289.251,748.92 287.585,747.587 286.5,745.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd9386",
    d: "M 409.5,744.5 C 412.891,745.529 415.557,747.529 417.5,750.5C 414.467,748.984 411.8,746.984 409.5,744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c59a89",
    d: "M 662.5,745.5 C 661.415,747.587 659.749,748.92 657.5,749.5C 658.585,747.413 660.251,746.08 662.5,745.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ae8270",
    d: "M 273.5,750.5 C 275.5,751.833 277.167,753.5 278.5,755.5C 275.833,754.833 274.167,753.167 273.5,750.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94533d",
    d: "M 644.5,759.5 C 644.011,762.324 642.344,763.657 639.5,763.5C 639.891,766.838 638.724,767.838 636,766.5C 634.2,767.32 632.366,767.986 630.5,768.5C 634.819,765.004 639.485,762.004 644.5,759.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b79487",
    d: "M 450.5,771.5 C 453.485,772.326 456.151,773.659 458.5,775.5C 455.246,775.206 452.579,773.873 450.5,771.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be9585",
    d: "M 722.5,774.5 C 725.367,774.369 727.033,775.703 727.5,778.5C 725.809,777.136 724.142,775.803 722.5,774.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3a18f",
    d: "M 705.5,774.5 C 703.095,775.768 700.428,776.435 697.5,776.5C 699.838,774.96 702.505,774.294 705.5,774.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#caa39b",
    d: "M 487.5,785.5 C 490.428,785.565 493.095,786.232 495.5,787.5C 492.505,787.706 489.838,787.04 487.5,785.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c19484",
    d: "M 660.5,793.5 C 658.574,795.293 656.241,796.293 653.5,796.5C 655.426,794.707 657.759,793.707 660.5,793.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ddc0b3",
    d: "M 367.5,798.5 C 373.789,800.32 379.789,802.653 385.5,805.5C 378.69,804.842 372.69,802.508 367.5,798.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1b4aa",
    d: "M 455.5,822.5 C 461.051,822.527 466.384,823.194 471.5,824.5C 468.552,824.223 465.719,824.556 463,825.5C 460.666,823.98 458.166,822.98 455.5,822.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogarius);
export default __webpack_public_path__ + "static/media/catalogarius.f976b5a2.svg";
export { ForwardRef as ReactComponent };